import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import 'css/components/batches/DetailsHeader.css';

import Traductor from 'components/Traductor';
import NotificationBox from 'components/batches/NotificationBox';
import Tag from 'components/bronson/Tag';
import TagFilters from 'components/vehicleFilters/TagFilters';

const DetailsHeader = ({ data, dispatch, filters, filtersOptions }) => {
    const t = useMemo(() => new Traductor(), []);

    if (!data?.Name) {
        return (
            <div id="c-details-header-container" className="u-1/1 u-p-none">
                <span className="skeleton-details-title u-float-left u-1/3" />
            </div>
        );
    }

    return (
        <>
            <div
                id="c-details-header-container"
                className="o-layout__item u-1/1 u-p-none"
            >
                <div className="o-layout__item u-3/4 u-1/1@s u-p-none u-pr u-pr-none@s u-mr u-mr-none@s u-mb">
                    <p className="u-h6 u-mb">
                        {t.getTraduction('ClosedBatch')}
                    </p>
                    <div className="u-flex">
                        <h1 className="u-mb-none u-mr">{data?.Name}</h1>
                        {data?.AmountMax ? (
                            <Tag
                                classes={[
                                    'c-vehicle-card__tag-bid',
                                    'u-text-center u-mr@s u-p-small@s',
                                    data?.AmountMax === data?.Amount
                                        ? 'success'
                                        : 'error',
                                ]}
                                text={
                                    data?.AmountMax === data?.Amount
                                        ? t.getTraduction('WinningBid')
                                        : t.getTraduction('BidExceeded')
                                }
                            />
                        ) : null}
                    </div>
                    {!!filters?.filterBrands?.length && (
                        <div
                            id="TagFiltersList"
                            className="o-layout__item u-pl-none u-pt"
                        >
                            <ul className="c-tag-list">
                                <TagFilters
                                    refreshFilters={data => {
                                        dispatch({
                                            type: 'UPDATE_FILTERS',
                                            payload: { data },
                                        });
                                    }}
                                    filters={filters}
                                    filtersOptions={filtersOptions}
                                    resetFilters={() => {
                                        dispatch({ type: 'RESET_FILTERS' });
                                    }}
                                />
                            </ul>
                        </div>
                    )}
                </div>
                <button
                    className="c-btn  c-btn--icon u-float-right"
                    onClick={() => dispatch({ type: 'SHOW_FILTERS' })}
                >
                    <i className="c-btn__icon c-icon  c-icon--[control-filter-02] c-icon--xsmall" />
                    <span className="c-btn__text u-pr-xsmall">
                        {t.getTraduction('Filters')}
                    </span>
                </button>
            </div>
            <div className="o-layout__item u-3/4 u-1/1@s u-p-none u-pr u-pr-none@s u-mr u-mr-none@s u-mb">
                <NotificationBox
                    type="warning"
                    message={t.getTraduction('ClosedBatchAmountWarning')(
                        data?.DifferentialAmount
                    )}
                />
            </div>
        </>
    );
};

DetailsHeader.propTypes = {
    data: PropTypes.shape({
        Name: PropTypes.string,
        DifferentialAmount: PropTypes.number,
        Amount: PropTypes.number,
        AmountMax: PropTypes.number,
    }),
    dispatch: PropTypes.func,
    pFilters: PropTypes.object,
    filters: PropTypes.object,
};

export default DetailsHeader;
